import { Injectable, Directive } from '@angular/core';
import { FormControl, Validator, ValidatorFn, AbstractControl } from '@angular/forms';
import { InterfaceElementRegularExpressions } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-re';
import { InterfaceElementDataTypes } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-datatype';
import { CosyCommunicationControllerService } from '../controller/cosy-communication-controller.service';
import { LocaleTypes } from 'src/app/model/locale/locale-type';

@Injectable()
export class CosyCustomizedValidationService {

  constructor(private cosyCommunicationControllerService: CosyCommunicationControllerService) {
  }

  static validateNumeric(value) {
    let num;
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      num = value;
    } else {
      num = Date.parse(value);
    }
    if (typeof num == 'undefined' || Number.isNaN(num)) {
      num = '';
    }
    return num;
  }
  //   /^[-a-z0-9~!$%^&*_=+}{\\'?]+(\\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\\.[-a-z0-9_]+)*\\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$/i

  static typeValidator(datatype: string): ValidatorFn {
    return (control: FormControl) => {
      let result;
      if (control.value != '' && control.value != null) {
        if (datatype == InterfaceElementDataTypes.IntegerDT) {
          if (InterfaceElementRegularExpressions.IntegerRE.test(control.value)) {
            return null;
          } else {
            return {
              numericDT: {
                valid: false
              }
            };
          }
        }
        if (datatype == InterfaceElementDataTypes.DateDT) {
          /*if (InterfaceElementRegularExpressions.DateRE_DDMMYYYYhhmmssS.test(control.value)||
          InterfaceElementRegularExpressions.DateRE_DDMMYYYY.test(control.value)) {
            return null;
          }*/ 
         
          if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE && /^([0][0-9]|(1)[0-2])(\/)(([0-2][0-9])|((3)[0-1]))(\/)\d{4}$/.test(control.value) ){
              return null;
          }

          else if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE && /^([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}$/.test(control.value)){
            return null;
          }
          
          else if(typeof(control.value) == 'object' && control.value['year']!= null && control.value['month']!= null && control.value['day']!= null){
            return null;
          }
          else {
            return {
              dateDT: {
                valid: false
              }
            };
          }
        }
      }
    };
  }

  static maskValidator(mask: RegExp): ValidatorFn {
    return (control: FormControl) => {
      if (control.value != '' && control.value != null) {
        if (control.value.match(mask)) {
          return null;
        } else {
          return {
            mask: {
              valid: false
            }
          };
        }
      }
    };
  }

  static maxValidator(max: any): ValidatorFn {
    return (control: FormControl) => {
      let numericValue;
      if (control.value != '' && control.value != null) {
        numericValue = CosyCustomizedValidationService.validateNumeric(control.value);
        max = CosyCustomizedValidationService.validateNumeric(max);
        if (numericValue <= max) {
          return null;
        } else {
          return {
            maximum: {
              valid: false
            }
          };
        }
      }
    };
  }

  static minValidator(min: any): ValidatorFn {
    return (control: AbstractControl) => {
      let numericValue;
      if (control.value != '' && control.value != null) {
        numericValue = CosyCustomizedValidationService.validateNumeric(control.value);
        min = CosyCustomizedValidationService.validateNumeric(min);
        if (numericValue >= min) {
          return null;
        } else {
          return {
            minimum: {
              valid: false
            }
          };
        }
      }
    };
  }

  static selectValidatorIndex0(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value != null) {
        if (control.value != '00000000-0000-0000-0000-000000000000') {
          return null;
        } else {
          return {
            index0: {
              valid: false
            }
          };
        }
      }
    };
  }

  static selectValidatorIndex0andRequierd(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value != '' && control.value != null) {
        if (control.value != '00000000-0000-0000-0000-000000000000') {
          return null;
        } else {
          return {
            index0: {
              valid: false
            },
            required: {
              valid: false
            }
          };
        }
      }
    };
  }

  static selectValidator1(selectedValue: any): ValidatorFn {
    return (control: AbstractControl) => {
      if (selectedValue != '' && selectedValue != null) {
        return null;
      } else {
        return {
          isSelected: {
            valid: false
          }
        };
      }
    };
  }

  static selectValidator(selectedValue: any): ValidatorFn {
    return (control: FormControl) => {
      if (control.value.value != '' && control.value.value != null && control.value.value.Value !== '') {
        return null;
      } else {
        return {
          isSelected: {
            valid: false
          }
        };
      }
    };
  }
}
